module.exports = __webpack_public_path__ + "static/media/bulkactions.8ecae996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clothespin/bulkactions.png
// module id = 351
// module chunks = 0